import React from 'react'

import { faFileExport } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { CSVLink } from 'react-csv'

const CsvExportButton = ({ data, headers, filename, buttonText }: any) => {
  return (
    <CSVLink
      data={data || ''}
      headers={headers}
      filename={filename}
      className={`p-1.5 rounded-md border text-center border-primary text-primary`}
    >
      {buttonText} <FontAwesomeIcon icon={faFileExport} />
    </CSVLink>
  )
}

export default CsvExportButton
